export const Permission = {
    overview:'overview',
    finances:'finances',
    dashboard:'dashboard',
    transaction:'transaction',
    doctors:'doctors',
    patients:'patients',
    users:'users',
    payments:'payments',
    consultationrate:'consultation-rate',
    reports:'reports',
    locations:'locations'
};
